import { PolicyCreateUseCase } from '../../../application';

export default class PolicyCreateServices {
    constructor() {}

    async execute(event) {
        const request = await PolicyCreateUseCase(event);

        return request;
    }
}
